module.exports = require("npm:events@1.0.2/events.js");